// extracted by mini-css-extract-plugin
export default {"buttonSecondary":"myButton_buttonSecondary__T0XJH","icon":"myButton_icon__vVH5r"};